import type { UserPrivate } from '@repo/types/users';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ParentKey } from '#parent/keys';

import { UserKey } from './keys';
import { UserService } from './userService';

export function useDeleteUser() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => UserService.deleteUser(id).then((response) => response.data),
    onMutate: async (id: number) => {
      await queryClient.cancelQueries({ queryKey: [UserKey.USERS] });

      const previousUsers = queryClient.getQueryData<UserPrivate[]>([UserKey.USERS]);

      queryClient.setQueryData([UserKey.USERS], (prev?: UserPrivate[]) => {
        if (!prev) {
          return [];
        }
        return prev.filter((user: UserPrivate) => user.id !== id);
      });

      return { previousUsers };
    },
    onError: (error, _id, context) => {
      if (context?.previousUsers) {
        queryClient.setQueryData<UserPrivate[]>([UserKey.USERS], context.previousUsers);
      }
    },
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: [UserKey.USERS] });
      void queryClient.invalidateQueries({ queryKey: [ParentKey.PARENTS] });
    },
  });
}
